import { render, staticRenderFns } from "./AppOverview.vue?vue&type=template&id=2a32f298&scoped=true&"
import script from "./AppOverview.vue?vue&type=script&lang=js&"
export * from "./AppOverview.vue?vue&type=script&lang=js&"
import style0 from "./AppOverview.vue?vue&type=style&index=0&id=2a32f298&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a32f298",
  null
  
)

export default component.exports